import { observable } from 'mobx';
import createHtmlLink from '@src/utils/create-html-link';

const styles = require('./index.less');

class FollowUsStore {
  @observable isActive = false;
  @observable config = {};
  @observable
  followList = [
    { id: 1, name: '企业微信', img: require('./images/img-qw.png'), text: require('./images/text-qw.png'), qrcode: require('./images/qiyeweixin.jpg') },
    { id: 2, name: '微信公众号', img: require('./images/img-gzh.png'), text: require('./images/text-gzh.png'), qrcode: require('./images/weixin.jpg') },
    {
      id: 3,
      name: '官方微博',
      img: require('./images/img-wb.png'),
      text: require('./images/text-wb.png'),
      qrcode: require('./images/weibo.jpg'),
      link: 'https://weibo.com/u/7478851023'
    },
    // { id: 4, name: '小红书', img: require('./images/img-xhs.png'), text: require('./images/text-xhs.png'), qrcode: require('./images/qrcode.png') },
    {
      id: 5,
      name: '抖音',
      img: require('./images/img-douyin.png'),
      text: require('./images/text-douyin.png'),
      qrcode: require('./images/douyin.jpg'),
      link: 'https://v.douyin.com/s3N2vr8ImxM/'
    }
    // {
    //   id: 6,
    //   name: '贴吧',
    //   img: require('./images/img-tb.png'),
    //   text: require('./images/text-tb.png'),
    //   qrcode: require('./images/douyin.jpg'),
    //   link: 'https://v.douyin.com/s3N2vr8ImxM/'
    // }
  ];

  clickNav = item => {
    if (item.link) {
      const link = createHtmlLink(item.link);
      link.target = '_blank';
      link.click();
    }
  };

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  use() { }
}
export default FollowUsStore;
